import React,{useState,useEffect} from 'react'
import "../css/Createpost.css";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function Createpost() {
  const [body, setBody] = useState("");
  const [bodyCount, setBodyCount] = useState(0);
  const [aboutPost, setAboutPost] = useState("");
  const [aboutPostCount, setAboutPostCount] = useState(0);
  const [files, setFiles] = useState([]); // selected files
  const [urls, setUrls] = useState([]); // uploaded urls and types
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate()

  // Toast Functions
  const notifyA = (msg) => toast.error(msg)
  const notifyB = (msg) => toast.success(msg)


  useEffect(() => {
    // when all media urls obtained, submit post
    if(urls.length > 0) {
      fetch("/createPost",{
        method:"post",
        headers:{
          "Content-Type":"application/json",
          "Authorization": "Bearer " + localStorage.getItem("jwt")
        },
        body:JSON.stringify({
          body,
          aboutPost,
          media: urls
        })
      }).then(res=>res.json())
      .then(data=> {if(data.error){
        notifyA(data.error)
      }else{
        notifyB("Successfully Posted")
        navigate("/")
      }})
      .catch(err => console.log(err))
      .finally(() => setIsUploading(false))
    }
  }, [urls]);

  // upload all selected files to Cloudinary
  const postDetails = async () => {
    setIsUploading(true);
    if (!aboutPost || !aboutPost.trim()) { notifyA('Please add About Post'); setIsUploading(false); return; }
    if (aboutPost.length > 700) { notifyA('About Post cannot exceed 700 characters'); setIsUploading(false); return; }
    if (files.length === 0) {
      notifyA("Please select at least one file");
      setIsUploading(false);
      return;
    }
    if (files.length > 5) {
      notifyA("You can upload at most 5 items");
      setIsUploading(false);
      return;
    }
    const uploaded = [];
    for (const file of files) {
      // helper to upload a blob/file to Cloudinary image endpoint
      const uploadImageBlob = async (blob, name = 'file.jpg') => {
        const data = new FormData();
        data.append('file', blob, name);
        data.append('upload_preset', 'linkalikes');
        data.append('cloud_name','linkalikescloud');
        const res = await fetch('https://api.cloudinary.com/v1_1/linkalikescloud/image/upload', { method: 'post', body: data });
        return await res.json();
      };

      const generateVideoThumbnail = (videoFile) => new Promise((resolve, reject) => {
        const url = URL.createObjectURL(videoFile);
        const vid = document.createElement('video');
        vid.preload = 'metadata';
        vid.src = url;
        vid.muted = true;
        vid.playsInline = true;
        const cleanup = () => { try{ URL.revokeObjectURL(url); }catch(e){} };
        vid.addEventListener('loadedmetadata', () => {
          const seekTo = Math.min(1, vid.duration / 2);
          const handler = () => {
            const canvas = document.createElement('canvas');
            canvas.width = vid.videoWidth || 320;
            canvas.height = vid.videoHeight || 180;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(vid, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
              cleanup();
              if (blob) resolve(blob); else reject(new Error('Canvas toBlob failed'));
            }, 'image/jpeg', 0.8);
            vid.removeEventListener('seeked', handler);
          };
          vid.addEventListener('seeked', handler);
          try { vid.currentTime = seekTo; } catch (e) { /* ignore */ }
        });
        vid.addEventListener('error', (e) => { cleanup(); reject(e); });
      });

      const data = new FormData();
      // choose resource type based on mime
      const isVideo = file.type.startsWith('video/');
      try {
        if (isVideo) {
          // generate thumbnail blob
          let thumbBlob;
          try {
            thumbBlob = await generateVideoThumbnail(file);
          } catch (e) {
            console.warn('thumbnail generation failed', e);
            thumbBlob = null;
          }
          let thumbUrl = null;
          if (thumbBlob) {
            try {
              const thumbRes = await uploadImageBlob(thumbBlob, 'thumb.jpg');
              thumbUrl = thumbRes.secure_url || thumbRes.url || null;
            } catch (e) { console.warn('thumbnail upload failed', e); }
          }
          // upload video
          data.append("file", file);
          data.append("upload_preset", "linkalikes");
          data.append("cloud_name","linkalikescloud");
          const videoRes = await fetch('https://api.cloudinary.com/v1_1/linkalikescloud/video/upload', { method: 'post', body: data });
          const videoResult = await videoRes.json();
          if (videoResult.error) throw videoResult.error;
          uploaded.push({ url: videoResult.secure_url || videoResult.url, type: 'video', thumbnail: thumbUrl });
        } else {
          data.append("file", file);
          data.append("upload_preset", "linkalikes");
          data.append("cloud_name","linkalikescloud");
          const res = await fetch('https://api.cloudinary.com/v1_1/linkalikescloud/image/upload', { method: 'post', body: data });
          const result = await res.json();
          if (result.error) throw result.error;
          uploaded.push({ url: result.secure_url || result.url, type: 'image' });
        }
      } catch (e) {
        console.error('upload error', e);
        notifyA('Upload failed');
      }
    }
    setUrls(uploaded);
  }


  const loadfile = (event) =>{
      const selected = Array.from(event.target.files);
      if (selected.length + files.length > 5) {
        notifyA('Maximum 5 items allowed');
        return;
      }
      setFiles(prev => [...prev, ...selected]);
  };

  const onDragStart = (e, index) => {
    e.dataTransfer.setData('text/plain', index);
  };

  const onDragOver = (e) => {
    e.preventDefault();
  };

  const onDrop = (e, index) => {
    e.preventDefault();
    const from = Number(e.dataTransfer.getData('text/plain'));
    const to = index;
    if (isNaN(from)) return;
    setFiles(prev => {
      const copy = Array.from(prev);
      const [moved] = copy.splice(from,1);
      copy.splice(to,0,moved);
      return copy;
    });
  };

  const removeFile = (index) => {
    setFiles(prev => prev.filter((_,i)=>i!==index));
  };
  const moveLeft = (index) => {
    setFiles(prev => {
      const copy = Array.from(prev);
      if (index <= 0) return copy;
      const [item] = copy.splice(index,1);
      copy.splice(index-1,0,item);
      return copy;
    });
  };
  const moveRight = (index) => {
    setFiles(prev => {
      const copy = Array.from(prev);
      if (index >= copy.length-1) return copy;
      const [item] = copy.splice(index,1);
      copy.splice(index+1,0,item);
      return copy;
    });
  };
  return (
    <div className='createPost'>
        {/* header */}
        <div className="post-header">
          <h4 style={{margin:"3px auto"}}>Create New Post</h4>
          <button id="post-btn" onClick={() => { postDetails() }} disabled={isUploading}>{isUploading ? 'Sharing...' : 'Share'}</button>
        </div>
        {/* media-preview */}
        <div className="main-div" style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'}}>
            <div style={{display:'flex',gap:'10px',flexWrap:'wrap',justifyContent:'center'}}>
                {files.map((f,idx)=>{
                const previewUrl = URL.createObjectURL(f);
                return (
                  <div key={idx} className="preview-item" draggable onDragStart={(e)=>onDragStart(e, idx)} onDragOver={onDragOver} onDrop={(e)=>onDrop(e, idx)} style={{position:'relative'}}>
                    <button className="preview-delete" onClick={(e)=>{e.stopPropagation(); removeFile(idx)}} style={{color:"black", position:'absolute',right:4,top:4,zIndex:5,background:'#fff',border:'none',borderRadius:'50%',padding:'2px 6px',cursor:'pointer'}}>✕</button>
                    <div style={{position:'absolute',left:6,top:6,zIndex:5,display:'flex',gap:6}}>
                      <button onClick={(e)=>{e.stopPropagation(); moveLeft(idx)}} style={{color:"black", background:'#fff',border:'none',borderRadius:6,padding:'2px 6px',cursor:'pointer'}}>◀</button>
                      <button onClick={(e)=>{e.stopPropagation(); moveRight(idx)}} style={{color:"black", background:'#fff',border:'none',borderRadius:6,padding:'2px 6px',cursor:'pointer'}}>▶</button>
                    </div>
                    {f.type.startsWith('image/') ? (
                      <img src={previewUrl} alt="preview" style={{width:'100px',height:'100px',objectFit:'cover',borderRadius:'8px'}} />
                    ) : (
                      <div style={{width:100,height:100,overflow:'hidden',borderRadius:8,background:'#000',display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <video src={previewUrl} style={{width:'100%',height:'100%',objectFit:'cover'}} muted />
                        <div style={{position:'absolute',color:'#fff',fontSize:20}}>🎬</div>
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
            <input 
              type="file" 
              accept='image/*,video/*' 
              multiple
              onChange={loadfile} 
            />
        </div>
        {/* details */}
        <div className="details">
            <div className="card-header">
                <div className="card-pic">
                    <img 
                      src="https://cdn-icons-png.flaticon.com/128/1177/1177568.png" 
                      alt="" 
                    />
                </div>
                <h5>You</h5>
            </div>
            <div style={{marginBottom:8}}>
              <textarea value={aboutPost} onChange={(e)=>{ setAboutPost(e.target.value); setAboutPostCount(e.target.value.length); }} placeholder='About Post (brief) — describe this post' maxLength={700} style={{width:'100%',padding:'8px',minHeight: '160px'}} />
              <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{aboutPostCount}/700</div>
            </div>
            <div style={{marginTop:8}}>
              <textarea
                className="caption-textarea"
                value={body}
                onChange={(e)=>{ setBody(e.target.value); setBodyCount(e.target.value.length); }}
                placeholder='Write a caption...'
                maxLength={130}
              />
              <div style={{textAlign:'right',fontSize:12,color:'#666'}}>{bodyCount}/130</div>
            </div>
        </div>

    </div>
  );
}
